export const VITE_APP_ATMO_SERVICE_ID = import.meta.env
  .VITE_APP_ATMO_SERVICE_ID;
export const VITE_APP_CLOUD_ID = import.meta.env.VITE_APP_CLOUD_ID;
